export default __webpack_public_path__ + "static/media/Ubuntu-BI.9ed30ae2.woff";